/**
 * formatRelativeTime returns a human-readable relative time string.
 * e.g. "Just now", "5m ago", "3h ago", "2d ago", or "12 Apr".
 */
export const formatRelativeTime = (dateString: string): string => {
  const now = Date.now();
  const date = new Date(dateString).getTime();
  const diff = now - date;

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;

  return new Date(dateString).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
};

const NUMBER_WORDS = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
];

/**
 * formatCount spells a count out in words up to ten, as in running text, and
 * gives larger ones as digits. e.g. "three", "12".
 */
export const formatCount = (count: number): string =>
  NUMBER_WORDS[count] ?? String(count);
